import React, { useEffect } from "react";
import { graphql } from "gatsby";
import { GatsbyImage, getImage, withArtDirection } from "gatsby-plugin-image";
import TwitterIcon from "../images/ico-tw.svg";
import FacebookIcon from "../images/ico-fb.svg";
import InstagramIcon from "../images/ico-ig.svg";
import LinkedinIcon from "../images/ico-li.svg";
import MediumIcon from "../images/ico-medium.svg";
import TumblrIcon from "../images/ico-tumblr.svg";
import BehanceIcon from "../images/ico-behance.svg";
import GithubIcon from "../images/ico-github.svg";
import WebIcon from "../images/ico-url.svg";
import { Link } from "gatsby";
import { Seo } from "../components/Seo";
import { useStore } from "../utils/store";

import Layout from "../components/Layout";

const TeamMember = (props) => {
  const member = props.data.member;
  const [translatePath, setTranslatePath] = useStore((state) => [
    state.translatePath,
    state.setTranslatePath,
  ]);

  const trans =
    props.data.member.translations.length > 0
      ? props.data.member.translations[0].uri
      : null;

  useEffect(() => {
    setTranslatePath(trans);
  }, [trans, setTranslatePath]);

  const images = withArtDirection(
    getImage(member.teamFields.pictureSquare.localFile),
    [
      {
        media: "(max-width: 767px)",
        image: getImage(member.teamFields.pictureSquare.localFile),
      },
    ]
  );

  return (
    <Layout
      location={props.location}
      localizedSlug={translatePath}
      isPostTemplate
    >
      <section className="container mx-auto flex grid-cols-12 flex-col border-b border-silver md:grid xl:border-x">
        <div className="relative col-span-7 flex flex-col justify-between border-r border-silver text-xl">
          <span className="hidden px-6 py-8 md:inline ">
            <Link to="/somos">Somos</Link> &gt; {member.title}
          </span>
          <div className="flex grid-cols-3 flex-col divide-x divide-silver border-t border-silver md:grid ">
            <div className="col-span-2 flex flex-col px-6 py-6 md:py-8">
              <h1 className="  font-serif text-3xl font-bold md:text-4xl">
                {member.title}
              </h1>
              <span className="text-base">{member.teamFields.role}</span>
            </div>

            {/* <div className="col-span-1 flex flex-col px-6 pb-6 font-serif md:py-8">
              <span className="italic">Consultor asociado</span>
              <span className="text-2xl font-normal">
                {member.teamFields.country && member.teamFields.country}
              </span>
            </div> */}
          </div>
          {/* <p>{colaborador.teamFields.role}</p> */}
        </div>
        <div className="avatar relative order-first col-span-5 aspect-square md:order-none md:grid ">
          {member.featuredImage && (
            <GatsbyImage
              image={getImage(member.teamFields.pictureSquare.localFile)}
              alt={member.title}
              layout="fullWidth"
              style={{
                gridArea: "1/1",
                position: "absolute",
              }}
              className=" inset-0 z-0 h-auto w-full object-cover "
            />
          )}
        </div>
      </section>

      <section className="container mx-auto flex flex-row justify-between divide-x divide-silver border-silver xl:border-x">
        <div className="flex flex-col pt-6 md:pb-8">
          <h2 className="p-6 text-lg md:text-xl">About</h2>

          <div
            className="block__text text-8 flex flex-col space-y-8 p-6 text-lg leading-tight md:w-3/4 md:text-4xl"
            dangerouslySetInnerHTML={{ __html: member.content }}
          />
          <div
            className="block__text text-8 flex flex-col space-y-8 p-6 text-lg leading-tight md:w-3/4 md:text-4xl"
            dangerouslySetInnerHTML={{ __html: member.teamFields.expertise }}
          />
          {member.teamFields.social && (
            <ul className="flex space-x-6 px-6">
              {member.teamFields.social.map((el, i) => {
                return (
                  <li key={i}>
                    <a href={el.url} target="blank">
                      {el.network === "Twitter" ? (
                        <TwitterIcon className="h-10" />
                      ) : el.network === "Facebook" ? (
                        <FacebookIcon className="h-10" />
                      ) : el.network === "Instagram" ? (
                        <InstagramIcon className="h-10" />
                      ) : el.network === "LinkedIn" ? (
                        <LinkedinIcon className="h-10" />
                      ) : el.network === "Medium" ? (
                        <MediumIcon className="h-10" />
                      ) : el.network === "Behance" ? (
                        <BehanceIcon className="h-10" />
                      ) : el.network === "Github" ? (
                        <GithubIcon className="h-10" />
                      ) : el.network === "Tumblr" ? (
                        <TumblrIcon className="h-10" />
                      ) : el.network === "Web" ? (
                        <WebIcon className="h-10" />
                      ) : null}
                    </a>
                  </li>
                );
              })}
            </ul>
          )}
        </div>

        <div className="flex  flex-none flex-col "></div>
      </section>
    </Layout>
  );
};

export default TeamMember;

export const Head = (props) => {
  return (
    <Seo
      title={`${props.data.member.title} | UNIT - Diseñando el cambio`}
      description={props.data.member.seo.metaDesc}
      pathname={props.location.pathname}
      image={
        props.data.member.opengraphImage
          ? props.data.member.opengraphImage.localFile.childImageSharp
              .gatsbyImageData.images.fallback.src
          : props.data.member.featuredImage
          ? props.data.member.featuredImage.node.localFile.childImageSharp
              .gatsbyImageData.images.fallback.src
          : "/unit-card.png"
      }
    />
  );
};

export const pageQuery = graphql`
  query EquipoById(
    # these letiables are passed in via createPage.pageContext in gatsby-node.js
    $id: String!
    $previousEquipoId: String
    $nextEquipoId: String
    $language: String!
  ) {
    locales: allLocale(
      filter: { ns: { in: ["common", "about"] }, language: { eq: $language } }
    ) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
    member: wpEquipo(id: { eq: $id }) {
      id
      uri
      title
      content
      date(formatString: "DD.MM.YYYY")
      language {
        slug
      }
      translations {
        id
        slug
        uri
      }
      teamFields {
        role
        expertise
        pictureSquare {
          localFile {
            childImageSharp {
              gatsbyImageData(aspectRatio: 1)
            }
          }
        }
        social {
          network
          url
        }
        textColor
      }

      seo {
        metaDesc
        opengraphTitle
        opengraphUrl
        opengraphImage {
          localFile {
            childImageSharp {
              gatsbyImageData(
                layout: FIXED
                width: 880
                height: 495
                formats: JPG
                quality: 90
              )
            }
          }
        }
      }

      featuredImage {
        node {
          caption
          altText
          localFile {
            childImageSharp {
              gatsbyImageData(
                # aspectRatio: 2
                # width: 1800
                formats: [AUTO, WEBP, AVIF]
                placeholder: NONE
                webpOptions: { quality: 80 }
                quality: 80
              )
            }
          }
        }
      }
    }

    # this gets us the previous Project by id (if it exists)
    previous: wpEquipo(id: { eq: $previousEquipoId }) {
      uri
      title
    }

    # this gets us the next TeamMember by id (if it exists)
    next: wpEquipo(id: { eq: $nextEquipoId }) {
      uri
      title
    }
  }
`;
